(function () {
  'use strict';
  var O = window.OTM || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var currency = O.currency || 'USD';

  function money(cents) {
    var n = Number(cents) || 0;
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency, minimumFractionDigits: n % 100 === 0 ? 0 : 2, maximumFractionDigits: 2 }).format(n / 100);
    } catch (e) { return '$' + (n / 100).toFixed(n % 100 === 0 ? 0 : 2); }
  }
  // routes.cart_add_url is "/cart/add" — the Ajax API needs ".js" or it answers with HTML.
  function js(url) { return /\.js$/.test(url) ? url : url + '.js'; }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.hidden = true; }, 2600);
  }

  /* ---------- drawers ---------- */
  var DRAWERS = ['d-menu', 'd-search', 'd-cart'];
  var lastOpener = null;
  function openDrawer(id, opener) {
    DRAWERS.forEach(function (d) { var el = document.getElementById(d); if (el) el.hidden = d !== id; });
    $$('[aria-controls]').forEach(function (b) { b.setAttribute('aria-expanded', String(b.getAttribute('aria-controls') === id)); });
    var scrim = $('#scrim'); if (scrim) scrim.hidden = false;
    document.body.classList.add('lock');
    lastOpener = opener || document.activeElement;
    var el = document.getElementById(id);
    if (id === 'd-search') { setTimeout(function () { var q = $('#q'); if (q) q.focus(); }, 30); }
    else { var f = el && el.querySelector('button, a, input'); if (f) f.focus(); }
  }
  function closeDrawers() {
    DRAWERS.forEach(function (d) { var el = document.getElementById(d); if (el) el.hidden = true; });
    $$('[aria-controls]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    var s = $('#scrim'); if (s) s.hidden = true;
    document.body.classList.remove('lock');
    if (lastOpener && lastOpener.focus) lastOpener.focus();
    lastOpener = null;
  }

  document.addEventListener('click', function (e) {
    var flip = e.target.closest('[data-flip]');
    if (flip) {
      e.preventDefault();
      var card = flip.closest('[data-zc]');
      var on = !card.classList.contains('flip');
      card.classList.toggle('flip', on);
      flip.setAttribute('aria-pressed', String(on));
      return;
    }
    var opener = e.target.closest('[data-open]');
    if (opener) {
      e.preventDefault();
      var id = opener.getAttribute('data-open');
      if (id === 'd-cart') refreshCart();
      openDrawer(id, opener);
      return;
    }
    if (e.target.closest('[data-close]') || e.target.id === 'scrim') { closeDrawers(); return; }
    var rm = e.target.closest('[data-remove]');
    if (rm) { e.preventDefault(); changeLine(rm.getAttribute('data-remove'), 0); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- cart (Ajax API) ---------- */
  function renderCart(cart) {
    currency = cart.currency || currency;
    var count = cart.item_count, sub = cart.total_price;
    $$('[data-cart-count]').forEach(function (b) { b.textContent = count; b.hidden = count === 0; });
    var subEl = $('[data-cart-subtotal]'); if (subEl) subEl.textContent = money(sub);

    var meter = $('[data-ship-meter]');
    if (meter) {
      var freeAt = Number(O.freeShipAt) || 0;
      if (freeAt <= 0) {
        meter.textContent = 'Free shipping on all U.S. orders';
      } else {
        var rate = (window.Shopify && window.Shopify.currency && Number(window.Shopify.currency.rate)) || 1;
        freeAt = Math.round(freeAt * rate);
        var left = Math.max(0, freeAt - sub);
        var txt = count === 0 ? 'Free shipping over ' + money(freeAt) : left > 0 ? 'Add ' + money(left) + ' for free shipping' : 'Free shipping unlocked';
        meter.innerHTML = esc(txt) + '<i><b style="width:' + Math.min(100, Math.round(sub / freeAt * 100)) + '%"></b></i>';
      }
    }

    var box = $('[data-cart-lines]'); if (!box) return;
    if (!cart.items.length) { box.innerHTML = '<p class="empty">Nothing in here yet.</p>'; return; }
    var shoot = O.shoot || {};
    box.innerHTML = cart.items.map(function (it) {
      var img = shoot[it.handle] || (it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=240' : '');
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? esc(it.variant_title) + ' · ' : '';
      return '<div class="line">' +
        '<figure class="ph">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</figure>' +
        '<div><a class="line-nm" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        '<small>' + variant + 'Qty ' + it.quantity + '</small>' +
        '<button type="button" class="link-btn" data-remove="' + esc(it.key) + '">Remove</button></div>' +
        '<span class="price">' + money(it.final_line_price) + '</span></div>';
    }).join('');
  }
  function refreshCart() {
    return fetch(js(O.cartUrl || '/cart'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(renderCart)
      .catch(function () {});
  }
  function changeLine(key, qty) {
    return fetch(js(O.cartChangeUrl || '/cart/change'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(renderCart)
      .catch(function () { toast('Could not update your bag. Refresh and try again.'); });
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });

  /* ---------- product page ---------- */
  var form = document.getElementById('product-form');
  if (form) {
    var idInput = form.querySelector('[data-variant-id]');
    var sizes = form.querySelector('[data-sizes]');
    var hint = form.querySelector('[data-hint]');
    var pickedLbl = form.querySelector('[data-size-picked]');
    var atc = document.getElementById('atc');
    var notify = $('[data-notify]');
    var notifyTitle = $('[data-notify-title]');
    var notifyTags = $('[data-notify-tags]');
    var stickBtn = $('[data-stick-add]');
    var label = (atc && atc.getAttribute('data-label')) || O.t.add;
    var picked = !sizes || idInput.getAttribute('data-picked') === 'true';
    var pickedOut = false;

    function setAtc(b) {
      if (!atc) return;
      var out = b && b.getAttribute('data-out') === 'true';
      pickedOut = out;
      if (out) {
        atc.disabled = true; atc.textContent = 'Sold out in ' + b.getAttribute('data-title');
        if (stickBtn) { stickBtn.disabled = true; stickBtn.textContent = 'Sold out'; }
      } else {
        atc.disabled = false; atc.textContent = label + (b ? ' · ' + b.getAttribute('data-price') : '');
        if (stickBtn) { stickBtn.disabled = false; stickBtn.textContent = label; }
      }
      if (notify) {
        notify.hidden = !out;
        if (out && notifyTitle) notifyTitle.textContent = 'Sold out in ' + b.getAttribute('data-title');
        if (notifyTags) notifyTags.value = notifyTags.getAttribute('data-base') + (out ? ', size-' + b.getAttribute('data-title').toLowerCase() : '');
      }
    }

    if (sizes) sizes.addEventListener('click', function (e) {
      var b = e.target.closest('.size'); if (!b) return;
      $$('.size', sizes).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      picked = true;
      if (hint) hint.hidden = true;
      if (pickedLbl) pickedLbl.textContent = b.getAttribute('data-title');
      if (b.getAttribute('data-out') !== 'true') {
        idInput.value = b.getAttribute('data-variant');
        try { var u = new URL(location.href); u.searchParams.set('variant', idInput.value); history.replaceState(null, '', u); } catch (err) {}
      }
      setAtc(b);
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!atc || atc.disabled || pickedOut) return;
      if (!picked) {
        if (hint) hint.hidden = false;
        if (sizes) sizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var was = atc.textContent;
      atc.disabled = true; atc.textContent = O.t.adding;
      fetch(js(O.cartAddUrl || '/cart/add'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to bag'); return j; }); })
        .then(function () { return refreshCart(); })
        .then(function () { openDrawer('d-cart', atc); })
        .catch(function (err) { toast(err.message); })
        .then(function () { atc.disabled = false; atc.textContent = was; });
    });

    /* sticky add bar once the main button has scrolled away */
    var stick = $('[data-stick]');
    if (stick && atc) {
      var ticking = false;
      var updateStick = function () { ticking = false; stick.hidden = atc.getBoundingClientRect().bottom > 0; };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(updateStick); } }, { passive: true });
      updateStick();
      if (stickBtn) stickBtn.addEventListener('click', function () {
        if (!picked) { atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); if (hint) hint.hidden = false; return; }
        if (form.requestSubmit) form.requestSubmit(); else atc.click();
      });
    }

    /* after a restock signup the page reloads with ?customer_posted=true — keep the thank-you visible */
    if (notify && /customer_posted=true/.test(location.search)) { notify.hidden = false; notify.scrollIntoView({ block: 'center' }); }

    /* photo counter on phones */
    var track = $('[data-track]'), count = $('[data-count]');
    if (track && count) track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      count.textContent = (i + 1) + ' / ' + track.children.length;
    }, { passive: true });
  }

  /* ---------- sort ---------- */
  $$('[data-autosubmit]').forEach(function (s) { s.addEventListener('change', function () { s.form.submit(); }); });

  /* ---------- predictive search ---------- */
  var q = $('#q'), res = $('#q-res'), searchTimer;
  if (q && res) q.addEventListener('input', function () {
    var v = q.value.trim();
    clearTimeout(searchTimer);
    if (v.length < 2) { res.innerHTML = ''; return; }
    searchTimer = setTimeout(function () {
      fetch((O.searchUrl || '/search/suggest') + '.json?q=' + encodeURIComponent(v) + '&resources[type]=product&resources[limit]=6', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var ps = (j.resources && j.resources.results && j.resources.results.products) || [];
          var shoot = O.shoot || {};
          res.innerHTML = ps.length ? ps.map(function (p) {
            var src = shoot[p.handle] || p.image;
            var img = src ? '<img src="' + esc(src) + '" alt="" loading="lazy">' : '';
            return '<a class="card" href="' + esc(p.url) + '"><figure class="ph">' + img + '</figure><span class="card-nm">' + esc(p.title) + '</span><span class="price">' + money(Math.round(Number(p.price) * 100)) + '</span></a>';
          }).join('') : '<p class="empty">Nothing matches “' + esc(v) + '”.</p>';
        })
        .catch(function () {});
    }, 200);
  });

  /* ---------- try-on videos: play muted while on screen, tap for sound ---------- */
  var vcards = $$('[data-vcard]');
  if (vcards.length) {
    var load = function (card) { var v = card.querySelector('video'); if (v && !v.src && card.dataset.src) { v.src = card.dataset.src; } return v; };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = load(en.target); if (!v) return;
          if (en.isIntersecting && en.intersectionRatio > 0.55) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
          else v.pause();
        });
      }, { threshold: [0, 0.55, 1] });
      vcards.forEach(function (c) { io.observe(c); });
    }
    var modal = $('[data-vmodal]'), mv = $('[data-vmodal-video]'), mtag = $('[data-vmodal-tag]');
    var openVideo = function (card) {
      if (!modal || !mv) return;
      vcards.forEach(function (c) { var v = c.querySelector('video'); if (v) v.pause(); });
      mv.src = card.dataset.src; mv.currentTime = 0; mv.muted = false;
      if (mtag) {
        mtag.hidden = !card.dataset.url;
        mtag.href = card.dataset.url || '#';
        var n = $('[data-vmodal-name]'), pr = $('[data-vmodal-price]'), th = $('[data-vmodal-thumb]');
        if (n) n.textContent = card.dataset.name || '';
        if (pr) pr.textContent = card.dataset.price || '';
        if (th) { if (card.dataset.thumb) { th.src = card.dataset.thumb; th.hidden = false; } else th.hidden = true; }
      }
      modal.hidden = false; document.body.classList.add('lock');
      var p = mv.play(); if (p && p.catch) p.catch(function () {});
    };
    var closeVideo = function () { if (!modal || modal.hidden) return; mv.pause(); mv.removeAttribute('src'); mv.load(); modal.hidden = true; document.body.classList.remove('lock'); };
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-vclose]') || e.target === modal) { closeVideo(); return; }
      var card = e.target.closest('[data-vcard]');
      if (card && !e.target.closest('.vtag')) { e.preventDefault(); openVideo(card); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeVideo(); });
  }

  refreshCart();
})();
